<template>

  <div class="neu-card-ctn">
    <div class="neu-card mx-auto">
      <base-icon :src="src" white fullWidth shadow></base-icon>
    </div>
    <div class="subtitle mx-auto">
      <p v-html="paddedTitle"></p>
      <span v-html="paddedSubtitle">
      </span>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import BaseIcon from '../icons/BaseIcon.vue'

export default {
  name: 'neu-card',
  components: {
    Carousel,
    Slide,
    BaseIcon
  },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    subtitleLines: Number,
    titleLines: Number
  },
  computed: {
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines + 1)}` : this.title
    },
    paddedSubtitle () {
      return this.subtitleLines ? `${this.subtitle}${'<br>'.repeat(this.subtitleLines + 1)}` : this.subtitle
    }
  }
}
</script>

<style lang="scss">
.neu-card-ctn {
  .neu-card {
    display: flex;
    transition-duration: 7s;

    &:hover {
      @include desktop {
        padding: 4rem 8rem;
      }
      @include desktop-sm {
        padding: 4rem 4rem;
      }
      
      transition-duration: 7s;
    }
    
    /* box-shadow: $custom-shadow; */
    border: $border;
    border-radius: $border-radius;

    // Neu Icon vertically centered
    span {
      display: block;
    }
  }

  .subtitle  {
    text-align: left;
    margin-bottom: 10%;

    @include desktop {
      margin-top: 4rem;
    }
    

    p {
      color: $blue;
      font-weight: bold;
      font-size: 1.25rem;
      white-space: normal;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCard2.vue